// 任务
const state = {
    displayLogin: false,
   }
   
   const mutations = {
    isDisplayLogin (state, res) {
        state.displayLogin = res
      },
   }
   
   export default {
     state,
     mutations
   }